export default __webpack_public_path__ + "static/media/12-10.8de80dee.png";